const DIALOG_HASH = "#dialog"
export default {
  data() {
    return {
      dialog: false,
    }
  },
  watch: {
    "$route.hash"(newHash, oldHash) {
      if (newHash === DIALOG_HASH) {
        this.dialog = true;
      } else if (oldHash === DIALOG_HASH) {
        this.dialog = false;
      }
    },
    dialog(newValue) {
      if (this.$route.hash === DIALOG_HASH && newValue == false) {
        this.$router.back()
      }
    }
  },
  methods: {
    toggleDialog(open) {
      if (open) {
        if (this.$route.hash == DIALOG_HASH) {
          this.dialog = true;
        } else {
          this.$router.push(DIALOG_HASH);
        }
      } else {
        this.$router.back();
      }
    },
  },
}